import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveEntry32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMoveEntry32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M12.062 13.588a1.2 1.2 0 0 1-1.2 1.2H3.104a1.2 1.2 0 0 1 0-2.4h7.756a1.2 1.2 0 0 1 1.2 1.2m-.213 4.813a1.2 1.2 0 0 1-1.2 1.2H5.374a1.2 1.2 0 0 1 0-2.4h5.275a1.2 1.2 0 0 1 1.2 1.2m17.044-2.262a7.401 7.401 0 1 1-14.803 0 7.401 7.401 0 0 1 14.803 0m-2.4 0a5.002 5.002 0 1 0-10.004.002 5.002 5.002 0 0 0 10.004-.002"
            />
        </svg>
    );
}
export default memo(IconMoveEntry32);
